<script lang="ts">
    import { ArcgisSuggestion } from "../../models/location.interface";

    export let suggestion: ArcgisSuggestion;
    export let highlighted: Boolean;
</script>

<button id={suggestion.magicKey} class="list-group-item list-group-item-action" class:active={highlighted}
value={suggestion.text}>{@html suggestion.text}</button>

